import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

import Title from '../../components/Telephone/Title';

const Banner = styled.section`
    width: 100%;
    padding-top: 128px;
    background-image: linear-gradient(180deg, #DEDFE3 0%, #FBFBFB 100%);
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    text-align: center;

    @media only screen and (max-width: 1919px) {
        padding-top: 100px;
    }

    @media only screen and (max-width: 1365px) {
        padding-top: 77px;
    }

    @media only screen and (max-width: 1023px) {
        padding-bottom: 34px;
    }

    @media only screen and (max-width: 767px) {
        padding-top: 57px;
        padding-bottom: 0;
    }
`;

const Image = styled.div`
    width: 830px;
    height: 60%;
    margin: 0 auto;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        font-family: 'object-fit: contain';
    }

    @media only screen and (max-width: 1919px) {
        width: 615px;
    }

    @media only screen and (max-width: 1365px) {
        margin-top: 32px;
        width: 535px;
    }

    @media only screen and (max-width: 1023px) {
        width: 535px;
        margin-top: 56px;
    }

    @media only screen and (max-width: 767px) {
        width: 100%;
        margin-top: 60px;
        height: 300px;
    }
`;

const Button = styled(BaseButton)`
  width: 172px;
  margin: 55px auto 0;

  @media only screen and (max-width: 1919px) {
    margin-top: 37px;
  }

  @media only screen and (max-width: 1365px) {
    margin-top: 36px;
  }

  @media only screen and (max-width: 1023px) {
    margin-top: 46px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 28px;
  }
`;

export default class Channel extends Component {
    static propTypes = {
        title: PropTypes.string,
        text: PropTypes.string,
        image: PropTypes.string,
        backgroundGradient: PropTypes.string,
    };

    onScroll(e) {
        e.preventDefault();
        document.getElementById('formCallBack').scrollIntoView({
            behavior: 'smooth',
        });
    }

    render() {
        const { title, text, image, className } = this.props;

        return (
          <Banner className={className}>
              <Title as='h1' title={title} description={text} />
              <Button type='accent' href='#formCallBack' onClick={this.onScroll}>Подключить</Button>
              <Image>
                  <img src={image} alt='background'/>
              </Image>
          </Banner>
        );
    }
}
